<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 16 20">
    <g clip-path="url(#clip0_6892_8993)">
      <path
        d="M9.62783 0H0.777832V20H15.7778V6.24706L9.62783 0ZM10.0086 2.04706L13.7817 5.88235H10.0086V2.04706ZM1.93168 18.8235V1.17647H8.85476V7.05882H14.624V18.8235H1.93168Z"
        :class="colorClass"
      />
      <path d="M13.5278 10.6822V9.9646H3.02783V10.6822H13.5278Z" :class="colorClass" />
      <path d="M11.624 12.2352V11.5176H3.02787V12.2352H11.624Z" :class="colorClass" />
      <path d="M10.0085 13.7765V13.0588H3.02778V13.7765H10.0085Z" :class="colorClass" />
      <path d="M8.67017 15.3295V14.6118H3.0394V15.3295H8.67017Z" :class="colorClass" />
    </g>
    <defs>
      <clipPath id="clip0_6892_8993">
        <rect width="15" height="20" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
